import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManger";
import { AudioManager } from "../../AudioManager";
import { UndoContainer } from "./UndoContainer";

export class Tile extends Phaser.GameObjects.Container {

    public static id = 0;
    
    private static matchingTiles: boolean;

    public p: {c: number, r: number};
    public level: number;
    public id: number;
    public shadow: Phaser.GameObjects.Image;
    public markedAsHint: boolean;
    public tileImg: Phaser.GameObjects.Image;

    private matched: boolean;
    private markedAsSelected: boolean;
    private markedAsUnselectable: boolean;
    private selectedMark: Phaser.GameObjects.Image;
    private hintMark: Phaser.GameObjects.Image;
    private unselectableImg: Phaser.GameObjects.Image;
    private shadowBelow: Phaser.GameObjects.Image;

    private selectedTween: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene, type: string, p: {c: number, r: number}, level: number) {
        
        super(scene);

        this.id = Tile.id;
        Tile.id ++;

        this.type = type;
        this.p = p;
        this.level = level;
        this.matched = false;
        this.markedAsHint = false;
        this.markedAsSelected = false;
        this.markedAsUnselectable = false;

        this.shadowBelow = new Phaser.GameObjects.Image(this.scene, 4, 7, "texture_atlas_1", "tile_shadow");
        this.shadowBelow.alpha = .3;
        this.add(this.shadowBelow);

        this.tileImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.type);
        this.tileImg.setOrigin(BoardContainer.TILE_WIDTH / this.tileImg.width, BoardContainer.TILE_HEIGHT / this.tileImg.height);
        this.tileImg.setInteractive({useHandCursor: true});
        this.tileImg.on("pointerdown", this.onPointerDown, this);
        this.add(this.tileImg);

        const boardData = GameVars.mahjongEngine.boardData;

        this.shadow = new Phaser.GameObjects.Image(this.scene, 0, -1, "texture_atlas_1", "tile_silouette");
        this.shadow.setOrigin(this.tileImg.originX, this.tileImg.originY);
        this.shadow.alpha = (boardData.levels - 1 - this.level) / (boardData.levels) * .22;
        this.add(this.shadow);

        this.unselectableImg = new Phaser.GameObjects.Image(this.scene, 0, -1, "texture_atlas_1", "tile_silouette");
        this.unselectableImg.setOrigin(this.tileImg.originX, this.tileImg.originY);
        this.unselectableImg.visible = false;
        this.add(this.unselectableImg);

        this.hintMark = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.type + "_green");
        this.hintMark.setOrigin(this.tileImg.originX, this.tileImg.originY);   
        this.hintMark.visible = false;
        this.add(this.hintMark);

        this.selectedMark = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.type + "_yellow");
        this.selectedMark.setOrigin(this.tileImg.originX, this.tileImg.originY);
        this.selectedMark.visible = false;
        this.add(this.selectedMark);

        // TODO: BORRAR ESTO
        // const debugText = new Phaser.GameObjects.Text(this.scene, 0, 0, "c:" + this.p.c.toString() + " r:" + this.p.r.toString(), {fontFamily: "Arial", fontSize: "17px", color: "#ff0000"});
        // debugText.setOrigin(.5);
        // this.add(debugText);
    }

    public update(): void {

        if (this.matched) {
            this.shadowBelow.visible = false;
            return;
        }

        const boardData = GameVars.mahjongEngine.boardData;

        const alpha = (boardData.levels - 1 - this.level) / (boardData.levels) * .2;

        if (!this.matched && this.shadow.alpha !== alpha) {
            
            this.scene.tweens.add({
                targets: this.shadow,
                alpha: alpha,
                duration: 450,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }

        this.shadow.visible = !GameVars.markingUnselectableTiles;

        this.shadowBelow.visible = this.level === 0;

        if (GameVars.paused) {

            this.tileImg.setFrame("empty_tile");
            this.hintMark.visible = false;
            this.selectedMark.visible = false;

        } else {
            
            this.tileImg.setFrame(this.type);

            if (this.markedAsHint) {
                this.hintMark.visible = true;
            }   
    
            if (this.markedAsSelected) {
                this.selectedMark.visible = true;
            }
        }
    }

    public disable(): void {

        this.tileImg.disableInteractive();
    }

    public enable(): void {
        
        this.tileImg.setInteractive({useHandCursor: true});
    }

    public onGamePaused(): void {

      

       
    }

    public onGameResumed(): void {

       
    }

    public markAsHint(): void {

        this.markedAsHint = true;

        this.hintMark.visible = true;
        this.hintMark.alpha = 0;

        this.scene.tweens.add({
            targets: this.hintMark,
            alpha: 1,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    public unmarkAsHint(): void {

        if (!this.hintMark.visible) {
            return;
        }

        this.markedAsHint = false;

        this.scene.tweens.add({
            targets: this.hintMark,
            alpha: 0,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                this.hintMark.visible = false;
            },
            onCompleteScope: this
        });
    }

    public markAsSelected(): void {

        if (this.markedAsHint && GameVars.matchSet.length === 2) {
            return;
        }

        this.markedAsSelected = true;
        this.selectedMark.visible = true;
        this.selectedMark.alpha = 0;

        this.scene.tweens.add({
            targets: this.selectedMark,
            alpha: 1,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        const i = Math.floor(Math.random() * 4) + 1;
        AudioManager.playSound("piece_select_0" + i);
    }

    public unmarkAsSelected(): void {

        if (!this.selectedMark.visible) {
            return;
        }

        this.markedAsSelected = false;

        this.scene.tweens.add({
            targets: this.selectedMark,
            alpha: 0,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                this.selectedMark.visible = false;
            },
            onCompleteScope: this
        });
    }

    public markAsUnselectable(undo?: boolean): void {

        if (this.unselectableImg.visible) {
            return;
        }

        this.unselectableImg.visible = true;
        this.unselectableImg.alpha = 0;
        this.markedAsUnselectable = true;

        if (undo) {
            this.unselectableImg.alpha = .35;
        } else {
            this.scene.tweens.add({
                targets: this.unselectableImg,
                alpha: .35,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out
            });        
        }
    }

    public unmarkAsUnselectable(undo?: boolean): void {

        this.markedAsUnselectable = false;

        if (undo) {

            this.scene.tweens.add({
                targets: this.unselectableImg,
                alpha: 0,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    this.unselectableImg.visible = false;
                },
                onCompleteScope: this
            });

        } else {
            this.unselectableImg.alpha = 0;
            this.unselectableImg.visible = false;
        }
    }

    public changeType(type: string): void {

        const boardData = GameVars.mahjongEngine.boardData;

        // ponemos por encima una imagen de la ficha que se va a cambar
        const tmpImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", this.type);
        tmpImg.setOrigin(BoardContainer.TILE_WIDTH / this.tileImg.width, BoardContainer.TILE_HEIGHT / this.tileImg.height);
        this.add(tmpImg);

        const tmpShadow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tile_silouette");
        tmpShadow.setOrigin(tmpImg.originX, tmpImg.originY);
        tmpShadow.alpha = (boardData.levels - 1 - this.level) / (boardData.levels) * .55;
        this.add(tmpShadow);

        this.scene.tweens.add({
            targets: [tmpImg, tmpShadow],
            alpha: 0,
            duration: 750,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                tmpImg.destroy();
                tmpShadow.destroy();
            },
            onCompleteScope: this
        });

        this.type = type;

        this.tileImg.setTexture("texture_atlas_1", this.type);
        this.hintMark.setTexture("texture_atlas_1", this.type + "_green");
        this.selectedMark.setTexture("texture_atlas_1", this.type + "_yellow");
    }

    public shake(): void {

        this.scene.tweens.add({
            targets: this,
            x: this.x - 5,
            duration: 80,
            ease: Phaser.Math.Easing.Linear,
            yoyo: true,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    x: this.x + 4,
                    duration: 60,
                    ease: Phaser.Math.Easing.Linear,
                    yoyo: true,
                    onComplete: () => {
                        this.scene.tweens.add({
                            targets: this,
                            x: this.x + 3,
                            duration: 40,
                            ease: Phaser.Math.Easing.Linear,
                            yoyo: true
                        });
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        AudioManager.playSound("wrong_piece_selected");
    }

    public onMatch(tile: Tile): void {
        
        Tile.matchingTiles = true;

        this.matched = true;
        this.scene.tweens.killTweensOf(this);
        this.shadow.visible = false;

        const px = (this.x + tile.x) * .5;
        const py = (this.y + tile.y) * .5;

        let x1: number;
        let x2: number;

        let finalX: number;
        let finalY = UndoContainer.TILE_POSITION_Y;
        const tileWidth = BoardContainer.TILE_WIDTH * this.scale;

        if (this.x === tile.x) {

            if (this.y < tile.y) {
                x1 = px - tileWidth * 2.5;
                x2 = px - tileWidth - 10;

                finalX = UndoContainer.TILE_A_POSITION_X;
            } else {
                x1 = px + tileWidth * 2.5;
                x2 = px + tileWidth + 10;

                finalX = UndoContainer.TILE_B_POSITION_X;
            }

        } else if (this.x > tile.x) {
            x1 = px + tileWidth * 2.5;
            x2 = px + tileWidth + 10;

            finalX = UndoContainer.TILE_B_POSITION_X;
        } else {
            x1 = px - tileWidth * 2.5;
            x2 = px - tileWidth - 10;

            finalX = UndoContainer.TILE_A_POSITION_X;
        }

        const dx = Math.abs(this.x - x1);
        const dy = Math.abs(this.y - py);
        const d = Math.floor(Math.sqrt(dx * dx + dy * dy) * 10) / 10;

        let duration1 = d < 100 ? d * 3 : d * 2;

        this.scene.tweens.add({
            targets: this,
            x: x1,
            y: py,
            scaleX: 1.2 * this.scale,
            scaleY: 1.2 * this.scale,
            duration: duration1,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {

                Tile.matchingTiles = false;

                this.scene.tweens.add({
                    targets: this,
                    x: x2,
                    duration: 150,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    onComplete: () => {

                        this.unmarkAsHint();
                        this.unmarkAsSelected();
                        
                        // SE MUEVE HACIA EL UNDO CONTAINER
                        this.scene.tweens.add({
                            targets: this,
                            x: finalX,
                            y: finalY,
                            scaleX: UndoContainer.TILE_SCALE,
                            scaleY: UndoContainer.TILE_SCALE,
                            duration: 550,
                            delay: 550,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            onComplete: () => {
                                UndoContainer.currentInstance.onMatch();
                                this.destroy();
                            },
                            onCompleteScope: this
                        });

                        this.scene.time.delayedCall(600, () => {
                            AudioManager.playSound("pre_matched_pieces_fx");
                        }, [], this);
                    },
                    onCompleteScope: this
                });

                UndoContainer.currentInstance.showMatchFX();
            },
            onCompleteScope: this
        });

        AudioManager.playSound("pre_matched_pieces_fx");

        this.scene.time.delayedCall(duration1, () => {
            AudioManager.playSound("matched_pieces_fx");
        }, [], this);
    }

    private onPointerDown(): void {

        if (GameVars.paused || this.matched || Tile.matchingTiles) {
            return;
        }

        const tileData = {p: this.p, l: this.level, type: this.type};

        if (this.markedAsHint) {

            if (GameVars.matchSet.length > 2) {
                this.markAsSelected();
            }

            BoardManager.onTileMarkedAsHintSelected(tileData);
        } else {
            BoardManager.onTileSelected(tileData);
        }

        if (!this.matched) {

            this.setScale(1.05);

            this.selectedTween = this.scene.tweens.add({
                targets: this,
                scaleX: 1,
                scaleY: 1,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }
}
